import { render, staticRenderFns } from "./establishPage.vue?vue&type=template&id=1c5d8684&scoped=true"
import script from "./establishPage.vue?vue&type=script&lang=js"
export * from "./establishPage.vue?vue&type=script&lang=js"
import style0 from "./establishPage.vue?vue&type=style&index=0&id=1c5d8684&prod&lang=scss&scoped=true"
import style1 from "./establishPage.vue?vue&type=style&index=1&id=1c5d8684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d8684",
  null
  
)

export default component.exports